import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { VAvatar, VTooltip } from 'vuetify/lib'

@Component({})
export class AppAvatar extends Vue {
	@Prop({ type: String, required: true }) name!: string
	@Prop({ type: String, required: false }) image!: string

	render() {
		return (
			<VTooltip
				bottom
				dark
				color="primary"
				scopedSlots={{
					activator: ({ on }: { on: any }) => (
						<VAvatar {...{ attrs: this.$attrs }} on={on} color="#F5F5F5">
							{this.initials && <span class="font-weight-bold">{this.initials}</span>}
						</VAvatar>
					)
				}}
			>
				<span class="font-weight-bold">{this.name}</span>
			</VTooltip>
		)
	}

	get initials() {
		if (!this.name) return ' '

		let parts = this.name.split(/[ -]/)
		let initials = ''
		for (let i = 0; i < parts.length; i++) {
			initials += parts[i].charAt(0)
		}
		if (initials.length > 3 && initials.search(/[A-Z]/) !== -1) {
			initials = initials.replace(/[a-z]+/g, '')
		}
		initials = initials.substr(0, 3)
		return initials
	}
}
